function pad2(n) {
  return String(n).padStart(2, '0');
}

export function toIsoDate(date = new Date()) {
  return `${date.getFullYear()}-${pad2(date.getMonth() + 1)}-${pad2(date.getDate())}`;
}

export function addDaysToIso(iso, days) {
  const base = isoToDate(iso) || new Date();
  base.setDate(base.getDate() + days);
  return toIsoDate(base);
}

export function isoToDate(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(iso)) return null;
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function isoToPdfDateShort(iso) {
  const date = isoToDate(iso);
  if (!date) return '';
  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: '2-digit',
  });
}

export function isoToPdfDateLong(iso) {
  const date = isoToDate(iso);
  if (!date) return '';
  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });
}

/** Accept ISO or legacy MM/DD/YY display string for PDF meta block. */
export function formatQuoteDateForPdf(value, { longYear = false } = {}) {
  if (!value) {
    const now = new Date();
    return longYear ? isoToPdfDateLong(toIsoDate(now)) : isoToPdfDateShort(toIsoDate(now));
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return longYear ? isoToPdfDateLong(value) : isoToPdfDateShort(value);
  }
  return value;
}

export function defaultQuoteDateIso() {
  return toIsoDate(new Date());
}

export function defaultValidUntilIso(days = 30) {
  return addDaysToIso(defaultQuoteDateIso(), days);
}
